import { render, staticRenderFns } from "./MarkingsAssignList.vue?vue&type=template&id=812cf4e8&scoped=true"
import script from "./MarkingsAssignList.vue?vue&type=script&lang=js"
export * from "./MarkingsAssignList.vue?vue&type=script&lang=js"
import style0 from "./MarkingsAssignList.vue?vue&type=style&index=0&id=812cf4e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "812cf4e8",
  null
  
)

export default component.exports